import { MVFProfile, tranchesFromMVFProfile } from "@lib/tranche";
import { tranchifiedUnilateralAlloc } from "@lib/tranche/tranchifiedUnilateralAlloc";
import { FrontendEvaluation } from "./useEvaluatorEvaluationsCache";

export function runUnilateralAllocations(
  evaluations: FrontendEvaluation[],
  budget: number,
  holdProposalId: string,
): {
  [evaluableId: string]: {
    amount: number;
  };
} {
  if (evaluations.length === 0) {
    throw new Error(
      "Tried running S-Process with no evaluations, this should not be possible: there should always be a 'hold' proposal",
    );
  }

  const mvfProfile = mvfProfileFromEvaluations(evaluations);
  const trancheProfile = tranchesFromMVFProfile(mvfProfile);

  const allocs = tranchifiedUnilateralAlloc(
    trancheProfile,
    budget,
    holdProposalId,
  );

  return allocs;
}

function mvfProfileFromEvaluations(
  evaluations: FrontendEvaluation[],
): MVFProfile {
  const mvfProfile: MVFProfile = {};
  for (const evaluation of evaluations) {
    mvfProfile[evaluation.evaluableId] = evaluation.mvf;
  }

  return mvfProfile;
}
